import { AxiosInstance } from "axios";
import { pbxClient } from "@/api/clients/pbxClient";
import { sipClient } from "@/api/clients/sipClient";

export function getSipClient(): AxiosInstance {
    return sipClient;
}

/**
 * The pbx-api app-plane client (Cloudflare Worker at NEXT_PUBLIC_API_URL, :8793 locally). It
 * resolves the worker base URL and attaches the sipio-id Bearer.
 */
export function getPbxClient(): AxiosInstance {
    return pbxClient;
}
